<template>
  <div>
    <a-form
      ref="formRef"
      layout="vertical"
      :model="form"
    >
      <a-card :bordered="false">
        <!-- 团队领导 -->
        <template v-if="type === EDIT_ORGANIZATIONAL_OBJECTIVE">
          <!-- 团队建设 -->
          <a-form-item
            :label="$t('okr.personalObjective.teamBuilding')"
            :name="['organizationalSkills', 'teamBuilding']"
            :rules="{
              type: 'string',
              required: true,
              message: $t('okr.formRules.required.objective'),
              trigger: 'blur'
            }"
          >
            <div class="tip tip-main">
              ({{ $t('okr.personalObjective.teamBuildingTip1') }})
            </div>
            <!-- <div class="tip">
              {{ $t('okr.personalObjective.teamBuildingTip2') }}
            </div> -->
            <a-textarea
              v-model:value="form.organizationalSkills.teamBuilding"
              :placeholder="$t('okr.personalObjective.placeholder')"
              :auto-size="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
          <!-- 人才发展 -->
          <a-form-item
            :label="$t('okr.personalObjective.talentDevelopment')"
            :name="['organizationalSkills', 'talentDevelopment']"
            :rules="{
              type: 'string',
              required: true,
              message: $t('okr.formRules.required.objective'),
              trigger: 'blur'
            }"
          >
            <div class="tip tip-main">
              ({{ $t('okr.personalObjective.talentDevelopmentTip1') }})
            </div>
            <!-- <div class="tip">
              {{ $t('okr.personalObjective.talentDevelopmentTip2') }}
            </div> -->
            <a-textarea
              v-model:value="form.organizationalSkills.talentDevelopment"
              :placeholder="$t('okr.personalObjective.placeholder')"
              :auto-size="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
          <!-- 文化氛围 -->
          <a-form-item
            :label="$t('okr.personalObjective.culturalAtmosphere')"
            :name="['organizationalSkills', 'culturalAtmosphere']"
            :rules="{
              type: 'string',
              required: true,
              message: $t('okr.formRules.required.objective'),
              trigger: 'blur'
            }"
          >
            <div class="tip tip-main">
              ({{ $t('okr.personalObjective.culturalAtmosphereTip1') }})
            </div>
            <!-- <div class="tip">
              {{ $t('okr.personalObjective.culturalAtmosphereTip2') }}
            </div> -->
            <a-textarea
              v-model:value="form.organizationalSkills.culturalAtmosphere"
              :placeholder="$t('okr.personalObjective.placeholder')"
              :auto-size="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
        </template>
        <!-- 个人发展 -->
        <template v-else>
          <a-form-item
            :label="$t('okr.personalObjective.professionalPrecipitation')"
            :name="['personalDevelopment', 'professionalPrecipitation']"
            :rules="{
              type: 'string',
              required: true,
              message: $t('okr.formRules.required.objective'),
              trigger: 'blur'
            }"
          >
            <div class="tip tip-main">
              ({{ $t('okr.personalObjective.professionalPrecipitationTip1') }})
            </div>
            <div class="tip">
              {{ $t('okr.personalObjective.professionalPrecipitationTip2') }}
            </div>
            <!-- <div class="tip">
              {{ $t('okr.personalObjective.professionalPrecipitationTip3') }}
            </div>
            <div class="tip">
              {{ $t('okr.personalObjective.professionalPrecipitationTip4') }}
            </div> -->
            <a-textarea
              v-model:value="form.personalDevelopment.professionalPrecipitation"
              :placeholder="$t('okr.personalObjective.placeholder')"
              :auto-size="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
          <a-form-item
            :label="$t('okr.personalObjective.abilityBreakthrough')"
            :name="['personalDevelopment', 'abilityBreakthrough']"
            :rules="{
              type: 'string',
              required: true,
              message: $t('okr.formRules.required.objective'),
              trigger: 'blur'
            }"
          >
            <div class="tip tip-main">
              ({{ $t('okr.personalObjective.abilityBreakthroughTip1') }})
            </div>
            <!-- <div class="tip">
              {{ $t('okr.personalObjective.abilityBreakthroughTip2') }}
            </div>
            <div class="tip">
              {{ $t('okr.personalObjective.abilityBreakthroughTip3') }}
            </div>
            <div class="tip">
              {{ $t('okr.personalObjective.abilityBreakthroughTip4') }}
            </div> -->
            <a-textarea
              v-model:value="form.personalDevelopment.abilityBreakthrough"
              :placeholder="$t('okr.personalObjective.placeholder')"
              :auto-size="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
        </template>
      </a-card>
    </a-form>
    <FormAction
      :loading="loading"
      :can-close="canClose"
      @cancel="$emit('cancel')"
      @save="save()"
    />
  </div>
</template>

<script>
import { defineComponent, ref, toRefs, unref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'

import FormAction from './FormAction'
import { updatePersonalObjective } from '@/api/okr'
import { EDIT_ORGANIZATIONAL_OBJECTIVE } from '@/constants/okr-edit-type'
export default defineComponent({
  name: 'EditPersonalObjectiveForm',
  components: {
    FormAction
  },
  props: {
    okrListId: {
      type: Number,
      required: true
    },
    initForm: {
      type: Object,
      required: true
    },
    canClose: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  emits: ['update:can-close', 'personal-objective-saved', 'cancel'],
  setup (props, { emit }) {
    const { t } = useI18n()
    const formRef = ref()
    const { initForm } = toRefs(props)
    const form = unref(initForm)
    const loading = ref(false)

    watch(form, () => {
      emit('update:can-close', false)
    })

    async function save () {
      loading.value = true
      try {
        await formRef.value.validate()
      } catch (_) {
        loading.value = false
        return
      }

      const data = {
        organizational_skills: JSON.stringify({
          teamBuilding: form.organizationalSkills.teamBuilding,
          talentDevelopment: form.organizationalSkills.talentDevelopment,
          culturalAtmosphere: form.organizationalSkills.culturalAtmosphere
        }),
        personal_development: JSON.stringify({
          professionalPrecipitation:
            form.personalDevelopment.professionalPrecipitation,
          abilityBreakthrough: form.personalDevelopment.abilityBreakthrough
        })
      }

      return updatePersonalObjective(props.okrListId, data).then(() => {
        loading.value = false
        message.success(t('okr.editObjectiveDialog.successMessage'))
        emit('personal-objective-saved')
      }).catch(e => {
        loading.value = false
      })
    }

    return {
      form,
      formRef,
      save,
      EDIT_ORGANIZATIONAL_OBJECTIVE,
      loading
    }
  }
})
</script>
<style lang="less" scoped>
.tip {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.56);
  margin-bottom: 4px;
  padding-left: 10px;
}
.tip-main {
  padding-bottom: 12px;
}

:deep(.ant-form-item-label){
  label {
    font-weight: 700;
  }
}
</style>
